import axios from "axios";

export const getCompanyData = async () => {
  try {
    const cachedData = localStorage.getItem("companyData");
    if (cachedData) {
      return JSON.parse(cachedData);
    }

    const response = await axios.get(
      `${process.env.REACT_APP_APP_URL}/companies`,
      {
        headers: {
          "X-Platform": process.env.REACT_APP_X_PLATFORM,
          "API-Key": process.env.REACT_APP_API_KEY,
          "X-API-Version": process.env.REACT_APP_X_API_VERSION,
        },
        withCredentials: true,
      }
    );

    if (response.data.success) {
      const companyData = response.data.data[0];
      localStorage.setItem("companyData", JSON.stringify(companyData));

      return companyData;
    } else {
      throw new Error("Failed to fetch company data");
    }
  } catch (error) {
    console.error("Error fetching company data:", error);
    return null;
  }
};
